// @ts-nocheck
import React from 'react';
import { IGSyncTask } from './types';

interface Props {
  tasks: IGSyncTask[];
  isScraperConnected: boolean;
  hasCurrentCommand: boolean;
  onProcessTask: (task: IGSyncTask) => void;
  onSkipTask: (task: IGSyncTask) => void;
}

const TaskQueue: React.FC<Props> = ({ tasks, isScraperConnected, hasCurrentCommand, onProcessTask, onSkipTask }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
      <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 flex justify-between items-center">
        <h2 className="text-lg font-semibold text-gray-900">Task Queue</h2>
        <span className="bg-gray-200 text-gray-700 px-2 py-0.5 rounded text-xs font-bold">{tasks.length} PENDING</span>
      </div>

      {tasks.length === 0 ? (
        <div className="px-6 py-12 text-center text-gray-400">
          <h3 className="text-sm font-medium">No pending tasks in queue</h3>
          <p className="text-xs">New tasks will appear here automatically</p>
        </div>
      ) : (
        <div className="divide-y divide-gray-200">
          {tasks.map((task) => (
            <div key={task.id} className="p-6 hover:bg-gray-50 transition-colors">
              <div className="flex items-start justify-between">
                <div className="space-y-1">
                  <div className="flex items-center space-x-2">
                    <span className={`w-2 h-2 rounded-full ${task.status === 'in_progress' ? 'bg-blue-500' : 'bg-yellow-500'}`} />
                    <span className="text-xs font-black uppercase text-gray-400 tracking-tighter">{task.status}</span>
                    <span className="text-xs text-gray-400 font-mono">#{task.id.slice(0, 6)}</span>
                  </div>
                  <p className="text-sm font-bold text-gray-900">Shop: {task.shopId}</p>
                  <a href={task.instagramUrl} target="_blank" rel="noreferrer" className="text-sm text-blue-600 hover:underline block truncate max-w-md">
                    {task.instagramUrl}
                  </a>
                </div>
                <div className="flex space-x-2">
                  <button
                    onClick={() => onProcessTask(task)}
                    disabled={!isScraperConnected || hasCurrentCommand}
                    className="px-4 py-2 bg-blue-600 text-white text-sm font-bold rounded-lg hover:shadow-md disabled:bg-gray-100 disabled:text-gray-400 transition-all shrink-0"
                  >
                    Start
                  </button>
                  <button
                    onClick={() => onSkipTask(task)}
                    disabled={!isScraperConnected || hasCurrentCommand}
                    className="px-4 py-2 hover:bg-gray-200 text-gray-600 text-sm font-bold rounded-lg disabled:opacity-0 transition-all shrink-0"
                  >
                    Skip
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TaskQueue;
